<script>
import gsap from "gsap";
import BubbleText from "~/components/Hero/BubbleText.vue";

export default {
  name: "Space",
  components: { BubbleText },
  setup() {
    const yourEventDiv = ref();
    const route = useRoute();
    const { t } = useI18n();

    const scrollToContent = () => {
      const offsetTop = yourEventDiv.value.offsetTop;
      window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: "smooth",
      });
    };

    onMounted(() => {
      if (route.hash === "#vase-akce" || route.hash === "#your-event") {
        nextTick(() => {
          setTimeout(() => {
            scrollToContent();
          }, 500);
        });
      }
    });

    useHeadMeta({
      title: t("spaces.meta.title"),
      description: t("spaces.meta.description"),
      url: route.fullPath,
      csUrl: 'cs/prostor',
      enUrl: 'en/space',
      image:
        "https://www.opero.cz/img/6_Opero_Prague1_event_rent_conference_workshop_business_meeting_most_beautiful_space.jpg",
    });

    return {
      yourEventDiv,
    };
  },
  data() {
    return {
      imageListAlts: [],
      imageList: [],
      imageList2: [
        "/img/Opero_byznys_hub_soukroma_kavarna_pronajem.jpg",
        "/img/Opero_soukroma_kavarna_praha_byznys_hub_coworking.jpg",
        "/img/Opero_soukroma_kavarna_terasa_stare_mesto_praha.jpg",
        "/img/Opero_cowork_soukroma_terasa_prostor_pro_praci.jpg",
        "/img/Opero_kavarna_k_pronajmu_Praha1.jpg",
      ],
      localePath: useLocalePath(),
      currentImage: 0,
      currentImage2: 0,
      cursor: "",
      cursorStyle: {},
      width: 1365,
      xTo: null,
      yTo: null,
      variables: { limit: 5 },
      featuredItemData: null,
      loading: false,
    };
  },
  computed: {
    getHeight() {
      if (this.width > 1350) return 1675;
      if (this.width > 950) return this.width + 300;
      return this.width + 200;
    },
  },
  async created() {
    const query = gql`
    query CustomPages {
      cpages(where: {language: ${this.$i18n.locale.toUpperCase()},title: "Prostory"}) {
      nodes {
        slug
        title
        homepageconfiguration {
          pageType
          spaceForEvents {
            copy
            photos {
              altText
              mediaItemUrl
            }
          }
          meetingRooms {
            copy
          }
          featuredItem {
            ... on Event {
              id
              title
              uri
              slug
              eventsConfig {
                perex
                datesettings {
                  timeEnd
                  timeFrom
                }
                featuredImage {
                  mediaItemUrl
                  sourceUrl
                  mediaDetails {
                    sizes {
                      width
                      sourceUrl
                    }
                  }
                }
              }
            }
            ... on Post {
							id
							title
							date
							title
							uri
							link
							slug
							status

							blogConfig {
								perex
								content
							}
							featuredImage {
								node {
								mediaItemUrl
									sourceUrl
									mediaDetails {
										sizes {
											width
											sourceUrl
										}
									}
								}
							}
						}
          }
        }
      }
    }
  }

`;
    const { data } = await useAsyncQuery(query, this.variables);
    this.featuredItemData = data;

    this.imageList = data?.value?.cpages?.nodes[0]?.homepageconfiguration?.spaceForEvents?.photos ? data?.value?.cpages?.nodes[0]?.homepageconfiguration?.spaceForEvents?.photos.map((p) => {
      return p.mediaItemUrl;
    }) : [];
    this.imageListAlts = data?.value?.cpages?.nodes[0]?.homepageconfiguration?.spaceForEvents?.photos ? data?.value?.cpages?.nodes[0]?.homepageconfiguration?.spaceForEvents?.photos.map((p) => {
      return p.altText;
    }) : [];
  },
  mounted() {
    const images = Array.from(document.querySelectorAll("img")); // Select all images
    const videos = Array.from(document.querySelectorAll("video")); // Select all videos
    const mediaElements = [...images, ...videos];

    const loadPromises = mediaElements.map(
      (element) =>
        new Promise((resolve) => {
          if (element.complete || element.readyState > 0) {
            resolve(null);
          } else {
            element.addEventListener("load", () => resolve(null), {
              once: true,
            });
          }
        })
    );

    Promise.all(loadPromises).then(() => {
      this.loading = false;
    });

    window.addEventListener("scroll", this.handleScroll);

    window.addEventListener("resize", this.handleResize);

    this.width =
      document.body.clientWidth ||
      window.innerWidth ||
      document.documentElement.clientWidth;
    if (this.width > 1024) {
      gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

      this.xTo = gsap.quickTo("#cursor", "x", {
        duration: 0.1,
        ease: "power3",
      });
      this.yTo = gsap.quickTo("#cursor", "y", {
        duration: 0.1,
        ease: "power3",
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    window.document.removeEventListener("click", this.cursorOnClick);
  },
  methods: {
    changeTestimonial(t) {
      this.currentImage = t;
    },
    changeTestimonial2(t) {
      this.currentImage2 = t;
    },

    setCursor(value, onClick, style) {
      this.cursor = value;
      if (this.cursorOnClick !== onClick) {
        window.document.removeEventListener("click", this.cursorOnClick);
        this.cursorOnClick = onClick;

        window.document.addEventListener("click", this.cursorOnClick);
      }
      if (this.cursorStyle !== style) {
        this.cursorStyle = style;
      }
    },
    cursorOnClick: () => {},
    mouseMove(e) {
      if (this.width > 1024 && this.xTo && this.yTo) {
        this.xTo(e.pageX);
        this.yTo(e.pageY);
      }
    },
    handleScroll() {},
    handleResize() {
      this.width =
        document?.body?.clientWidth ||
        window?.innerWidth ||
        document?.documentElement?.clientWidth;
      if (this.width > 1024) {
        gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

        this.xTo = gsap.quickTo("#cursor", "x", {
          duration: 0.1,
          ease: "power3",
        });
        this.yTo = gsap.quickTo("#cursor", "y", {
          duration: 0.1,
          ease: "power3",
        });
      }
    },
  },
};
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
  <div @mousemove="mouseMove">
    <div class="overflow-hidden">
      <div class="navbar-wrapper">
        <Navbar
          :is-dark="true"
          @mouseover="
            setCursor(null, null, {
              'font-size': '14px',
              cursor: 'unset',
              'z-index': '1',
              width: '25px',
              height: '25px',
              opacity: 0.7,
            })
          "
        />
      </div>

      <div class="relative">
        <Bubbles
          v-if="width + 22 > 1024"
          :key="width"
          :height="getHeight"
          :start-width="700"
          :start-height="0"
          :set-cursor="setCursor"
          ref-prop="canvasSpaces"
        />
        <div
          class="w-full flex justify-center lg:absolute lg:top-0 pt-28 lg:pt-32 pointer-events-none"
        >
          <div class="w-[1280px] max-w-7xl">
            <div class="pointer-events-none w-full">
              <div class="flex pb-12 lg:pb-24 px-2.5 xs:px-6">
                <AnimateTitle :title="$t('spaces.title')" />
              </div>
              <div class="w-full flex justify-center">
                <NuxtImg
                  sizes="1280px"
                  class="w-full max-w-7xl"
                  src="https://be.opero.cz/wp-content/uploads/2024/04/spaces_hero.png"
                  format="webp"
                  :placeholder="[1280, 714, 75, 75]"
                />
              </div>
            </div>
          </div>
        </div>

        <BubbleText
          class="relative spaces-bubbletext pointer-events-none"
          :set-cursor="setCursor"
        >
          <div
            class="bubbleText lg:absolute relative z-10 py-4 pt-12 lg:py-24 w-full max-w-7xl"
          >
            <div class="bubble-text pointer-events-none">
              <div class="pointer-events-none spaces-perex lg:px-6">
                <AnimatePerex :title="$t('spaces.perex')" />
              </div>
            </div>
          </div>
        </BubbleText>
      </div>
      <div
        v-if="
          featuredItemData?.cpages?.nodes[0]?.homepageconfiguration
            ?.featuredItem
        "
        class="lg:flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl w-full">
          <div class="lg:flex px-6 lg:px-8 heading-under-hero">
            <h2 class="h1 pb-0 lg:pb-0">
              {{ $t("spaces.blog.title") }}
            </h2>
          </div>
        </div>
      </div>

      <ActionList
        v-if="
          featuredItemData?.cpages?.nodes[0]?.homepageconfiguration
            ?.featuredItem
        "
        :featured-item="
          featuredItemData.cpages.nodes[0].homepageconfiguration.featuredItem
        "
        :set-cursor="setCursor"
      />

      <SpacesNavButtons
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      />
      <div
        id="meeting_rooms"
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row pt-12 p-6 md:px-6 md:p-16 gap-5 md:gap-32"
          >
            <h2 class="h1">{{ $t("spaces.meetingRooms.title") }}</h2>
            <div class="txt-l flex-2">
              <div class="!text-xl" v-html="featuredItemData?.cpages?.nodes[0]?.homepageconfiguration?.meetingRooms ? featuredItemData?.cpages?.nodes[0]?.homepageconfiguration
              ?.meetingRooms?.copy : ''" />
              <div class="flex sm:block">
                <button
                  class="bg-transparent border rounded-full border-black px-4 py-2 text-sm mt-6"
                  @mouseenter="
                    setCursor(null, null, {
                      'font-size': '14px',
                      background: '#FFC800',
                      width: '25px',
                      height: '25px',
                      'z-index': '-1',
                    })
                  "
                  @click="
                    navigateTo({
                      path: localePath({ name: 'contact' }),
                      query: { from: 'event', type: 'meeting_room' },
                    })
                  "
                >
                  {{ $t("spaces.meetingRooms.button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MeetingRooms :set-cursor="setCursor" />
      <div
        id="events"
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': -1,
          })
        "
      >
        <div ref="yourEventDiv" class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row py-12 p-6 md:px-6 md:p-16 gap-5 md:gap-32"
          >
            <div>
              <h2
                class="h1 whitespace-nowrap mb-2"
                v-html="$t('spaces.spaceForEvents.title')"
              />
              <h4
                class="h4 whitespace-nowrap border-black border-y max-w-fit"
                v-html="$t('spaces.spaceForEvents.capacity')"
              />
            </div>

            <div class="txt-l flex-2">
              <div class="!text-xl" v-html="featuredItemData?.cpages?.nodes[0]?.homepageconfiguration
            ?.spaceForEvents?.copy" />
              <button
                class="bg-transparent border rounded-full border-black px-4 py-2 text-sm mt-6"
                @mouseenter="
                  setCursor(null, null, {
                    'font-size': '14px',
                    background: '#FFC800',
                    width: '25px',
                    height: '25px',
                    'z-index': '-1',
                  })
                "
                @click="
                  navigateTo({
                    path: localePath({
                      name: 'space-id',
                      params: { id: 'akce' },
                    }),
                  })
                "
              >
                {{ $t("spaces.spaceForEvents.button") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="imageList?.length > 0" class="flex justify-center">
        <div class="max-w-7xl">
          <ImageCarousel
            id="firstSpaces"
            :key="imageList"
            :images="imageList"
            :alt-tags="imageListAlts"
            :current-image="currentImage"
            :change-testimonial="changeTestimonial"
            :set-cursor="setCursor"
          />
        </div>
      </div>

      <div
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': '-1',
          })
        "
      >
        <div class="max-w-7xl mt-8">
          <BubblesNavigationPaper
            :height="50"
            :width="40 * imageList.length"
            :start-width="50"
            :testimonials="imageList"
            :change-testimonial="changeTestimonial"
            :current-selected="currentImage"
          />
        </div>
      </div>

      <Coworking id="coworking" :set-cursor="setCursor" />

      <div
        id="cafe"
        class="flex justify-center"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': -1,
          })
        "
      >
        <div class="max-w-7xl">
          <div
            class="flex flex-col md:flex-row py-12 pt-20 p-6 md:px-6 md:p-16 gap-5 md:gap-28"
          >
            <h2 class="h1 lg:whitespace-nowrap">
              {{ $t("spaces.cafe.title") }}
            </h2>
            <div class="flex-2">
              <p class="!text-xl" v-html="$t('spaces.cafe.subtitle')" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="max-w-7xl">
          <ImageCarousel
            v-if="imageList2"
            id="secondSpaces"
            :images="imageList2"
            :current-image="currentImage2"
            :change-testimonial="changeTestimonial2"
            :set-cursor="setCursor"
          />
        </div>
      </div>

      <div class="flex justify-center">
        <div class="max-w-7xl mt-8">
          <BubblesNavigationPaper
            :height="50"
            :width="40 * imageList2.length"
            start-width="50"
            :testimonials="imageList2"
            :change-testimonial="changeTestimonial2"
            :current-selected="currentImage2"
            @mouseenter="
              setCursor(null, null, {
                'font-size': '14px',
                background: '#FFF',
                width: '0px',
                height: '25px',
                'z-index': '1000',
              })
            "
          />
        </div>
      </div>

      <BecomeMember class="mt-12" :set-cursor="setCursor" />
      <Footer :set-cursor="setCursor" />
      <div
        id="cursor"
        class="hidden cursor-auto lg:cursor-none lg:flex pointer-events-none"
        :style="cursorStyle"
        :class="{
          smallCursor: cursor === null,
        }"
        @click="cursorOnClick"
        v-html="cursor"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.spaces-bubbletext {
  position: relative;
  top: -598px;

  @media screen and (max-width: 1370px) {
    top: -39.35vw;
  }

  @media screen and (max-width: 1024px) {
    top: 0;
  }
}
.heading-under-hero {
  @media screen and (max-width: 1370px) {
    padding-top: 12vw;
  }
  @media screen and (max-width: 1270px) {
    padding-top: 15vw;
  }
  @media screen and (max-width: 1170px) {
    padding-top: 18vw;
  }
  @media screen and (max-width: 1110px) {
    padding-top: 23vw;
  }

  @media screen and (max-width: 1024px) {
    padding-top: 30px;
  }
}

#cursor {
  position: absolute;
  top: 0;
  left: -10px;
  width: 25px;
  height: 25px;
  display: none;
  font-weight: 400;

  justify-content: center;
  align-items: center;
  background-color: $color-primary;
  border-radius: 50%;
  z-index: 1000;
  cursor: none;
  transition:
    width 0.3s,
    height 0.3s,
    background-color 0.3s;
  transform: translate(-50%, -50%) translate(-150px, -150px);
  //pointer-events: none;
  text-align: center;
  @media screen {
    @media (pointer: fine) {
      display: flex;
    }
  }
}

.smallCursor {
  width: 20px;
  height: 20px;
  background-color: $color-primary;
}

.spaces-perex {
  max-width: 1050px;
}
</style>
